import { createRouter, createWebHistory } from 'vue-router';
import store from '../store';
import handleMiddleware from '../router/middleware-handler';

const routes = [
    {
        path: '/',
        name: 'home',
        component: () => import('../views/home/home.vue')
    },
    {
        path: '/pesquisas-realizadas',
        name: 'search-histories',
        component: () => import('../views/search-histories/search-histories.vue')
    },

    /** EMPRESAS **/
    {
        path: '/unidades',
        name: 'company',
        component: () => import('../views/companies/companies.vue')
    },
    {
        path: '/unidades/cadastrar',
        name: 'company.create',
        component: () => import('../views/companies/company-form.vue')
    },
    {
        path: '/unidades/editar/:id',
        name: 'company.update',
        component: () => import('../views/companies/company-form.vue')
    },

    /** CONFIGURAÇÃO DE BENEFICIOS **/
    {
        path: '/configuracao-beneficio',
        name: 'benefitsConfig',
        component: () => import('../views/benefits_config/benefits-config.vue')
    },
    {
        path: '/configuracao-beneficio/cadastrar',
        name: 'benefitsConfig.create',
        component: () => import('../views/benefits_config/benefits-config-form.vue')
    },
    {
        path: '/configuracao-beneficio/editar/:id',
        name: 'benefitsConfig.update',
        component: () => import('../views/benefits_config/benefits-config-form.vue')
    },

    /** CATEGORIA DE DOCUMENTOS **/
    {
        path: '/categoria-documentos',
        name: 'documentCategories',
        component: () => import('../views/document_categories/document-categories.vue')
    },

    /** CLIENTES EXTERNOS **/
    {
        path: '/clientes-externos',
        name: 'externalCustomers',
        component: () => import('../views/external-customers/external-customers.vue')
    },

    /** SETORES **/
    {
        path: '/setores',
        name: 'sector',
        component: () => import('../views/sector/sector.vue')
    },
    {
        path: '/setores/cadastrar',
        name: 'sector.create',
        component: () => import('../views/sector/sector-form.vue')
    },
    {
        path: '/setores/editar/:id',
        name: 'sector.update',
        component: () => import('../views/sector/sector-form.vue')
    },

    /** SINDICATOS **/
    {
        path: '/sindicatos',
        name: 'syndicate',
        component: () => import('../views/syndicates/syndicates.vue')
    },
    {
        path: '/sindicatos/cadastrar',
        name: 'syndicate.create',
        component: () => import('../views/syndicates/syndicate-form.vue')
    },
    {
        path: '/sindicatos/editar/:id',
        name: 'syndicate.update',
        component: () => import('../views/syndicates/syndicate-form.vue')
    },
    {
        path: '/sindicatos/:id',
        name: 'syndicate.view',
        component: () => import('../views/syndicates/syndicate-view.vue')
    },

    /** GRUPO SALARIAIS **/
    {
        path: '/grupos-salariais',
        name: 'wageGroups',
        component: () => import('../views/wage_groups/wage-group.vue')
    },
    {
        path: '/grupos-salariais/cadastrar',
        name: 'wageGroups.create',
        component: () => import('../views/wage_groups/wage-group-form.vue')
    },
    {
        path: '/grupos-salariais/editar/:id',
        name: 'wageGroups.update',
        component: () => import('../views/wage_groups/wage-group-form.vue')
    },
    {
        path: '/grupos-salariais/:id',
        name: 'wageGroups.view',
        component: () => import('../views/wage_groups/wage-group-view.vue')
    },

    /** CARGOS **/
    {
        path: '/cargos',
        name: 'position',
        component: () => import('../views/positions/positions.vue')
    },
    {
        path: '/cargos/cadastrar',
        name: 'position.create',
        component: () => import('../views/positions/positions-form.vue')
    },
    {
        path: '/cargos/deletados',
        name: 'position.disabled',
        component: () => import('../views/positions/positions-disabled.vue')
    },
    {
        path: '/cargos/editar/:id',
        name: 'position.update',
        component: () => import('../views/positions/positions-form.vue')
    },
    {
        path: '/cargos/visualizar/:id',
        name: 'position.view',
        component: () => import('../views/positions/positions.view.vue')
    },

    /** COLABORADORES **/
    {
        path: '/colaboradores',
        name: 'collaborator',
        component: () => import('../views/collaborators/collaborator.vue')
    },
    {
        path: '/colaboradores/cadastrar',
        name: 'collaborator.create',
        component: () => import('../views/collaborators/collaborator-form.vue')
    },
    {
        path: '/colaboradores/editar/:id',
        name: 'collaborator.update',
        component: () => import('../views/collaborators/collaborator-form.vue')
    },
    {
        path: '/colaboradores/visualizar/:id',
        name: 'collaborator.view',
        component: () => import('../views/collaborators/collaborator-view.vue')
    },

    {
        path: '/grupos-colaboradores',
        name: 'collaborator-group.view',
        component: () => import('../views/collaborator-group/collaborator-group.vue')
    },
    {
        path: '/grupos-colaboradores/cadastrar',
        name: 'collaborator-group.create',
        component: () => import('../views/collaborator-group/collaborator-group-form.vue')
    },
    {
        path: '/grupos-colaboradores/editar/:id',
        name: 'collaborator-group.update',
        component: () => import('../views/collaborator-group/collaborator-group-form.vue')
    },

    /** CLASSIFICAÇÕES DE CARGOS **/
    {
        path: '/classificacoes-cargos',
        name: 'classification_position',
        component: () => import('../views/classifications/classifications.vue')
    },
    {
        path: '/classificacoes-cargos/criterios',
        name: 'classification_position.criteria',
        component: () => import('../views/classifications/criteria.vue')
    },
    {
        path: '/classificacoes-cargos/criterios',
        name: 'classification_position.criteria',
        component: () => import('../views/classifications/criteria.vue')
    },
    {
        path: '/classificacoes-cargos/configuracoes',
        name: 'classification_position.settings',
        component: () => import('../views/classifications/jobClassificationsSettings.vue')
    },

    /** PESQUISA SALARIAL **/
    {
        path: '/pesquisa-salarial',
        name: 'salary_survey',
        component: () => import('../views/salary_survey/salary-survey.vue')
    },
    {
        path: '/pesquisa-salarial/resultado/:id',
        name: 'salary_survey.result',
        component: () => import('../views/salary_survey/result.vue')
    },
    {
        path: '/pesquisa-salarial/pesquisa/:id',
        name: 'salary_survey.search',
        component: () => import('../views/salary_survey/search.vue')
    },
    {
        path: '/pesquisa-salarial/pesquisa-beneficios/:id',
        name: 'salary_survey.search-benefits',
        component: () => import('../views/salary_survey/search-benefits.vue')
    },
    {
        path: '/pesquisa-salarial/adicionar-salario/:id',
        name: 'salary_survey.add_salary',
        component: () => import('../views/salary_survey/add-salary.vue')
    },
    {
        path: '/pesquisa-salarial/historicos/:id',
        name: 'salary_survey.histories',
        component: () => import('../views/salary_survey/salary-survey-histories.vue')
    },

    {
        path: '/pesquisa-salarial/dashboard',
        name: 'salary_survey.dashboard',
        component: () => import('../views/salary_survey/dashboard.vue')
    },
    
    /** PESQUISA BENEFÍCIOS **/
    {
        path: '/pesquisa-beneficios',
        name: 'benefit_survey',
        component: () => import('../views/benefit_survey/benefit-survey.vue')
    },

    {
        path: '/pesquisa-beneficios/resultado/:id',
        name: 'benefit_survey.view',
        component: () => import('../views/benefit_survey/benefit-survey-view.vue')
    },

    {
        path: '/pesquisa-beneficios/pesquisa/:id',
        name: 'benefit_survey.search',
        component: () => import('../views/benefit_survey/benefit-survey-search.vue')
    },

    {
        path: '/pesquisa-beneficios/historico/:id',
        name: 'benefit_survey.history',
        component: () => import('../views/benefit_survey/benefit-survey-history.vue')
    },
    
    /** PESQUISA CUSTOMIZADA */
    
    {
        path: '/pesquisa-customizada',
        name: 'segmented_survey',
        component: () => import('../views/segmented_survey/segmented-survey.vue')
    },
    {
        path: '/pesquisa-customizada/:id/',
        name: 'segmented_survey.view',
        component: () => import('../views/segmented_survey/segmented-survey-view.vue')
    },
    {
        path: '/pesquisa-customizada/:id/dashboard',
        name: 'segmented_survey.dashboard',
        component: () => import('../views/segmented_survey/segmented-survey-dashboard.vue')
    },
    {
        path: '/pesquisa-customizada/empresas',
        name: 'segmented_survey.company',
        component: () => import('../views/segmented_survey/segmented-survey-company.vue')
    },
    {
        path: '/pesquisa-customizada/:id/empresas-participantes',
        name: 'segmented_survey.participant_company',
        component: () => import('../views/segmented_survey/segmented-survey-participant-company.vue')
    },
    {
        path: '/pesquisa-customizada/:id/convidados/',
        name: 'segmented_survey.participant_company_invite',
        component: () => import('../views/segmented_survey/segmented-survey-invite.vue')
    },
    {
        path: '/pesquisa-customizada/:id/empresas-participantes/:cnpj/salarios',
        name: 'segmented_survey.company_salary',
        component: () => import('../views/segmented_survey/segmented-survey-participant-company-salary.vue')
    },
    {
        path: '/pesquisa-customizada/:id/empresas-participantes/:cnpj/beneficios',
        name: 'segmented_survey.company_benefit',
        component: () => import('../views/segmented_survey/segmented-survey-participant-company-benefit.vue')
    },
    {
        path: '/pesquisa-customizada/:id/empresas-participantes/:cnpj/questionario',
        name: 'segmented_survey.company_question',
        component: () => import('../views/segmented_survey/segmented-survey-participant-company-question.vue')
    },
    {
        path: '/pesquisa-customizada/:id/empresas-participantes/:cnpj/dashboard',
        name: 'segmented_survey.company_dashboard',
        component: () => import('../views/segmented_survey/segmented-survey-participant-company-dashboard.vue')
    },
    {
        path: '/pesquisa-customizada/:id/cargos/:position_id',
        name: 'segmented_survey.position-search',
        component: () => import('../views/segmented_survey/segmented-survey-salary-search.vue')
    },
    {
        path: '/pesquisa-customizada/:id/beneficios/:benefit_id',
        name: 'segmented_survey.benefit-search',
        component: () => import('../views/segmented_survey/segmented-survey-benefit-search.vue')
    },

    /** SEGMENTADA EXTERNA **/
    { 
        path: '/pesquisa-segmentada/:uuid/login',
        name: 'external_segmented_survey.login',
        meta: { layout: 'auth', middleware: ['segmented-survey-auth-middleware'] },
        component: () => import('../views/external_segmented_survey/segmented-survey-login.vue')
    },
    {
        path: '/pesquisa-segmentada/:uuid/cadastrar',
        name: 'external_segmented_survey.register',
        meta: { layout: 'auth', middleware: ['segmented-survey-auth-middleware'] },
        component: () => import('../views/external_segmented_survey/segmented-survey-register.vue')
    },
    {
        path: '/pesquisa-segmentada',
        name: 'external_segmented_survey.welcome',
        meta: { middleware: ['segmented-survey-auth-middleware'] },
        component: () => import('../views/external_segmented_survey/segmented-survey-welcome.vue')
    },
    {
        path: '/pesquisa-segmentada/salarios',
        name: 'external_segmented_survey.salary',
        meta: { middleware: ['segmented-survey-auth-middleware'] },
        component: () => import('../views/external_segmented_survey/segmented-survey-salary.vue')
    },
    {
        path: '/pesquisa-segmentada/beneficios',
        name: 'external_segmented_survey.benefit',
        meta: { middleware: ['segmented-survey-auth-middleware'] },
        component: () => import('../views/external_segmented_survey/segmented-survey-benefit.vue')
    },
    {
        path: '/pesquisa-segmentada/questionario',
        name: 'external_segmented_survey.question',
        meta: { middleware: ['segmented-survey-auth-middleware'] },
        component: () => import('../views/external_segmented_survey/segmented-survey-question.vue')
    },
    {
        path: '/pesquisa-segmentada/concluido',
        name: 'external_segmented_survey.finish',
        meta: { middleware: ['segmented-survey-auth-middleware'] },
        component: () => import('../views/external_segmented_survey/segmented-survey-finish.vue')
    },
    {
        path: '/pesquisa-segmentada/dashboard',
        name: 'external_segmented_survey.dashboard',
        meta: { middleware: ['segmented-survey-auth-middleware'] },
        component: () => import('../views/external_segmented_survey/segmented-survey-dashboard.vue')
    },
    
    /** DESCRIÇÃO DE CARGOS **/
    {
        path: '/descricao-cargos',
        name: 'position_description',
        component: () => import('../views/position_description/position_descriptions.vue')
    },
    {
        path: '/descricao-cargos/history/:id',
        name: 'position_description.change-history-show',
        component: () => import('../views/position_description/change-history-show.vue')
    },
    {
        path: '/descricao-cargos/atividades/:id',
        name: 'position.activities',
        component: () => import('../views/position_description/activities.vue')
    },

    /** CURVA SALARIAL **/
    {
        path: '/curva-salarial',
        name: 'salary_curve',
        component: () => import('../views/salary_curve/salary_curve.vue')
    },

    {
        path: '/curva-salarial/historico',
        name: 'salary_curve.change_history',
        component: () => import('../views/salary_curve/change_history.vue')
    },

    /** TABELA SALARIAL **/
    {
        path: '/tabela-salarial',
        name: 'salary_table',
        component: () => import('../views/salary_table/salary-table.vue')
    },
    {
        path: '/tabela-salarial/configuracoes',
        name: 'salary_table.config',
        component: () => import('../views/salary_table/salary-table-config.vue')
    },

    /** ADEQUAÇÃO TABELA **/
    {
        path: '/tabela-adequacao',
        name: 'suitability_table',
        component: () => import('../views/suitability_table/suitability_table.vue')
    },
    {
        path: '/tabela-adequacao/historico',
        name: 'suitability_history',
        component: () => import('../views/suitability_table/history.vue')
    },
    {
        path: '/tabela-adequacao/todos-indicadores',
        name: 'suitability_history.full_indicators',
        component: () => import('../views/suitability_table/full_indicators.vue')
    },

    /** CHART **/
    {
        path: '/organograma',
        name: 'chart',
        component: () => import('../views/chart-new/chart.vue')
    },
    {
        path: '/organograma-old',
        name: 'chart-old',
        component: () => import('../views/chart/chart.vue')
    },
    {
        path: '/organogramas',
        name: 'chart-v3.index',
        component: () => import('../views/chart-v3/Index.vue')
    },
    {
        path: '/organogramas/:id/board',
        name: 'chart-v3.edit',
        component: () => import('@/views/chart-v3/chart.vue'),
    },

    /** POLITICA SALARIAL **/
    {
        path: '/politica-salarial',
        name: 'salary_policy',
        component: () => import('../views/salary_policy/salary_policy.vue')
    },
    {
        path: '/politica-salarial/criterios-classificaccao',
        name: 'classification_criteria',
        component: () => import('../views/salary_policy/classification_criteria.vue')
    },
    {
        path: '/politica-salarial/historico',
        name: 'salary_policy.change_history',
        component: () => import('../views/salary_policy/change_history.vue')
    },

    /** USUÁRIOS **/
    {
        path: '/usuarios',
        name: 'user',
        component: () => import('../views/users/users.vue')
    },
    {
        path: '/usuarios/cadastrar',
        name: 'user.create',
        component: () => import('../views/users/user-form.vue')
    },
    {
        path: '/usuarios/:id',
        name: 'user.update',
        component: () => import('../views/users/user-form.vue')
    },

    /** CONFIGURAÇÕES **/
    {
        path: '/configuracao',
        name: 'settings',
        component: () => import('../views/settings/settings.vue')
    },

    /** Critérios de decisão - Avaliação de Desempenho **/
    {
        path: '/avaliacao-desempenho/criterios-decisao',
        name: 'decision-criteria',
        component: () => import('../views/evaluation/decision-criteria/decision-criteria.vue')
    },

    /** Avaliações **/
    {
        path: '/avaliacoes',
        name: 'evaluations',
        component: () => import('../views/evaluation/evaluation/evaluations.vue')
    },
    {
        path: '/avaliacoes/cadastrar',
        name: 'evaluations.create',
        component: () => import('../views/evaluation/evaluation/evaluation-form.vue')
    },
    {
        path: '/avaliacoes/editar/:id',
        name: 'evaluations.update',
        component: () => import('../views/evaluation/evaluation/evaluation-form.vue')
    },
    {
        path: '/avaliacoes/configuracao/:id',
        name: 'evaluations.setting',
        component: () => import('../views/evaluation/evaluation/evaluation-setting.vue')
    },
    {
        path: '/avaliacoes/questionario/:id',
        name: 'evaluations.question',
        component: () => import('../views/evaluation/evaluation/evaluation-question.vue')
    },
    {
        path: '/avaliacoes/avaliados/:id',
        name: 'evaluations.evaluated',
        component: () => import('../views/evaluation/evaluation/evaluation-evaluated.vue')
    },
    {
        path: '/avaliacoes/historicos/:id',
        name: 'evaluations.histories',
        component: () => import('../views/evaluation/evaluation/evaluation-histories.vue')
    },
    {
        path: '/avaliacoes/historicos/:id/vizualizar-avaliadores/:history',
        name: 'evaluations.histories-evaluators',
        component: () => import('../views/evaluation/evaluation/history-evaluated.vue')
    },
    {
        path: '/avaliacoes/questionario/:id/cargo/:positionId',
        name: 'evaluations.question.position',
        component: () => import('../views/evaluation/evaluation/position-question.vue')
    },

    /** Ranking **/
    {
        path: '/avaliacao-desempenho/ranking',
        name: 'ranking',
        component: () => import('../views/evaluation/ranking/ranking.vue')
    },

    /** Relatório Geral **/
    {
        path: '/avaliacao-desempenho/relatorio-geral',
        name: 'general',
        component: () => import('../views/evaluation/general-report/general-report.vue')
    },

    /** Relatório Por Colaborador **/
    {
        path: '/avaliacao-desempenho/relatorio-por-colaborador',
        name: 'evaluation.report-collaborator',
        component: () => import('../views/evaluation/collaborator-report/collaborator-report.vue')
    },

    /** Relatório Por Setor **/
    {
        path: '/avaliacao-desempenho/relatorio-por-setor',
        name: 'evaluation.report-sector',
        component: () => import('../views/evaluation/sector-report/sector-report.vue')
    },

    /** CAMPOS PERSONALIZADOS **/
    {
        path: '/campos-personalizados',
        name: 'custom-fields',
        component: () => import('../views/custom-fields/CustomFields.vue'),
    },

    {
        path: '/grupos-personalizados',
        name: 'custom-groups',
        component: () => import('../views/custom-fields/custom-groups.vue'),
    },

    /** PDI **/
    {
        path: '/avaliacao-desempenho/pdi',
        name: 'evaluation.pdi',
        component: () => import('../views/evaluation/pdi/pdi.vue')
    },
    {
        path: '/avaliacao-desempenho/pdi/:id',
        name: 'evaluation.pdi-setting',
        component: () => import('../views/evaluation/pdi/pdi-setting.vue')
    },
    {
        path: '/avaliacao-desempenho/pdi/:id/acompanhar',
        name: 'evaluation.pdi-view',
        component: () => import('../views/evaluation/pdi/pdi-view.vue')
    },
    {
        path: '/avaliacao-desempenho/pdi/:id/historico',
        name: 'evaluation.pdi-history',
        component: () => import('../views/evaluation/pdi/pdi-history.vue')
    },
    {
        path: '/avaliacao-desempenho/pdi-cadastrar',
        name: 'evaluation.pdi-create',
        component: () => import('../views/evaluation/pdi/pdi-create.vue')
    },

    /** Avaliações Externas **/
    {
        path: '/avaliacao/avaliado/login/:uuid',
        name: 'external-evaluations.evaluated-login',
        component: () => import('../views/external_evaluation/evaluated_login.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao/avaliado/form/:uuid',
        name: 'external-evaluations.evaluated-form',
        component: () => import('../views/external_evaluation/evaluated_form.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao/avaliados/:uuid',
        name: 'external-evaluations.evaluated-list',
        component: () => import('../views/external_evaluation/evaluator_list.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao/sucesso',
        name: 'external-evaluations.evaluated-success',
        component: () => import('../views/external_evaluation/evaluated_success.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao/avaliador/login/:uuid',
        name: 'external-evaluations.evaluators-login',
        component: () => import('../views/external_evaluation/evaluators_login.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao/avaliador/form/:uuid/:collaboratorId',
        name: 'external-evaluations.evaluator-form',
        component: () => import('../views/external_evaluation/evaluator_form.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao/avaliador/form-consensual/:uuid/:collaboratorId',
        name: 'external-evaluations.evaluator-form-consensual',
        component: () => import('../views/external_evaluation/evaluator_consensual_form.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao/avaliador/sucesso/:uuid',
        name: 'external-evaluations.evaluator-success',
        component: () => import('../views/external_evaluation/evaluator_success.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao-consensual/avaliador/form/:uuid/:collaboratorId',
        name: 'external-evaluations.consensual-evaluator-form',
        component: () => import('../views/external_evaluation/evaluator_consensual_form.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/avaliacao-consensual/avaliador/sucesso/:uuid',
        name: 'external-evaluations.consensual-evaluator-success',
        component: () => import('../views/external_evaluation/evaluator_consensual_success.vue'),
        meta: { layout: 'auth' }
    },

    /** AUTH **/
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/auth/login.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/logout',
        name: 'logout',
        component: () => store.dispatch('user/logout'),
        meta: { layout: 'auth' }
    },
    {
        path: '/recuperacao-senha/:token',
        name: 'recovery',
        component: () => import('../views/auth/recovery.vue'),
        meta: { layout: 'auth' }
    },
    {
        path: '/redefinir-senha/:token',
        name: 'reset',
        component: () => import('../views/auth/newPassword.vue'),
        meta: { layout: 'auth' }
    },

    /** ANÁLISE DESCRIÇÕES **/
    {
        path: '/analise-descricoes',
        name: 'descriptions_analysis',
        component: () => import('../views/description-analysis/description-analysis.vue')
    },
    {
        path: '/analise-descricoes/:id',
        name: 'descriptions_analysis.form',
        component: () => import('../views/description-analysis/description-analysis-form.vue')
    },
    
    /** CLIMATE SURVEY**/
    {
        path: '/pesquisa-clima',
        name: 'climate-survey',
        component: () => import('../views/climate-survey/climate-survey.vue'),
    },
    {
        path: '/pesquisa-clima/dashboard',
        name: 'climate-survey.general-dashboard',
        component: () => import('../views/climate-survey/climate-survey-general-dashboard.vue'),
    },
    {
        path: '/pesquisa-clima/cadastrar',
        name: 'climate-survey.create',
        component: () => import('../views/climate-survey/climate-survey-form.vue'),
    },
    {
        path: '/pesquisa-clima/fatores',
        name: 'climate-survey.factory',
        component: () => import('../views/climate-survey/climate-survey-factor.vue'),
    },
    {
        path: '/pesquisa-clima/:id/configuracao',
        name: 'climate-survey.setup',
        component: () => import('../views/climate-survey/climate-survey-setup.vue'),
    },
    {
        path: '/pesquisa-clima/:id/participantes',
        name: 'climate-survey.participant',
        component: () => import('../views/climate-survey/climate-survey-participant.vue'),
    },
    {
        path: '/pesquisa-clima/:id/questionario',
        name: 'climate-survey.question',
        component: () => import('../views/climate-survey/climate-survey-questionnaire.vue'),
    },
    {
        path: '/pesquisa-clima/:id/historicos',
        name: 'climate-survey.history',
        component: () => import('../views/climate-survey/climate-survey-history.vue'),
    },
    {
        path: '/pesquisa-clima/:id/dashboard',
        name: 'climate-survey.dashboard',
        component: () => import('../views/climate-survey/climate-survey-dashboard.vue'),
    },
    {
        path: '/pesquisa-clima/:id/ciclo/:instanceId/participantes',
        name: 'climate-survey.instance-participant',
        component: () => import('../views/climate-survey/climate-survey-instance-participant.vue'),
    },
    
    /** PORTAL */
    {
        path: '/portal',
        name: 'portal.home',
        component: () => import('../views/portal/home/home.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/descricao-cargo',
        name: 'portal.position-description',
        component: () => import('../views/portal/position-description/position-description.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/aprovacao-descricoes',
        name: 'portal.approval-description',
        component: () => import('../views/description-analysis/description-analysis.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/aprovacao-descricoes/:id',
        name: 'portal.approval-description.form',
        component: () => import('../views/description-analysis/description-analysis-form.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliacao-desempenho/relatorio-individual',
        name: 'portal.report',
        component: () => import('../views/portal/evaluations/individual-report.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliacoes/',
        name: 'portal.my-reviews',
        component: () => import('../views/portal/evaluations/my_reviews.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/minhas-avaliacoes',
        name: 'portal.my-reviews',
        component: () => import('../views/portal/evaluations/my_reviews.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/minhas-avaliacoes/:id',
        name: 'portal.my-reviews-form',
        component: () => import('../views/portal/evaluations/my_reviews_form.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/minhas-avaliacoes',
        name: 'portal.evaluate-collaborators',
        component: () => import('../views/portal/evaluations/my_reviews.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliar-equipe',
        name: 'portal.evaluate-teams',
        component: () => import('../views/portal/evaluations/evaluate_teams.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliacoes-consensuais',
        name: 'portal.evaluate-consensual',
        component: () => import('../views/portal/evaluations/evaluate_consensual.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliar-equipe/:evaluationHistoryId/:collaboratorId',
        name: 'portal.evaluate-teams-form',
        component: () => import('../views/portal/evaluations/evaluate_teams_form.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliacao-consensual/:evaluationHistoryId/:collaboratorId',
        name: 'portal.evaluate-consensual-form',
        component: () => import('../views/portal/evaluations/evaluate_consensual_form.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliar-colega',
        name: 'portal.evaluate-colleagues',
        component: () => import('../views/portal/evaluations/evaluate_colleagues.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliar-colega/:evaluationHistoryId/:collaboratorId/:evaluatorGroupId',
        name: 'portal.evaluate-colleagues-form',
        component: () => import('../views/portal/evaluations/evaluate_colleagues_form.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliacoes/questionarios',
        name: 'portal.avaliacoes.questionarios',
        component: () => import('../views/portal/evaluations/evaluation-question.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/avaliacoes/aprovacao-questionario/:id/cargo/:positionId',
        name: 'portal.avaliacoes.aprovacao-questionario',
        component: () => import('../views/evaluation/evaluation/position-question.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/meus-pdis',
        name: 'portal.pdi-collaborator',
        component: () => import('../views/portal/pdi/pdi-collaborator.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/meus-pdis/:id',
        name: 'portal.pdi-collaborator-view',
        component: () => import('../views/portal/pdi/pdi-view.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/gerenciar-pdis',
        name: 'portal.pdi-manager',
        component: () => import('../views/portal/pdi/pdi-manager.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/gerenciar-pdis/cadastrar',
        name: 'portal.pdi-manager-create',
        component: () => import('../views/evaluation/pdi/pdi-create.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/gerenciar-pdis/:id',
        name: 'portal.pdi-manager-view',
        component: () => import('../views/portal/pdi/pdi-view.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/gerenciar-pdis/:id/configuracoes',
        name: 'portal.pdi-manager-setting',
        component: () => import('../views/evaluation/pdi/pdi-setting.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/gerenciar-pdis/:id/pdis-realizados',
        name: 'portal.pdi-manager-history',
        component: () => import('../views/evaluation/pdi/pdi-history.vue'),
        meta: { layout: 'portal' }
    },

    /** REMUNERAÇÂO VARIÀVEL **/
    {
        path: '/portal/metas-e-indicadores',
        name: 'portal.variable-pay',
        component: () => import('../views/portal/variable-pay/variable-pay-view.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/metas-e-indicadores/colaboradores',
        name: 'portal.variable-pay-collaborators',
        component: () => import('../views/portal/variable-pay/varible-pay-collaborators.vue'),
        meta: { layout: 'portal' }
    },
    {
        path: '/portal/metas-e-indicadores/:id/colaboradores/:collaborator_id',
        name: 'portal.variable-pay-collaborators.view',
        component: () => import('../views/portal/variable-pay/variable-pay-collaborators-view.vue'),
        meta: { layout: 'portal' }
    },

    /** REMUNERAÇÂO VARIÀVEL **/
    {
        path: '/metas-e-indicadores',
        name: 'variable-pay',
        component: () => import('../views/variable_pay/variable-pay.vue')
    },
    {
        path: '/metas-e-indicadores/dashboard',
        name: 'variable-pay.dashboard',
        component: () => import('../views/variable_pay/variable-pay-dashboard.vue')
    },
    {
        path: '/metas-e-indicadores/ranking',
        name: 'variable-pay.ranking',
        component: () => import('../views/variable_pay/variable-pay-ranking.vue')
    },
    {
        path: '/metas-e-indicadores/cadastrar',
        name: 'variable-pay.create',
        component: () => import('../views/variable_pay/variable-pay-create.vue')
    },
    {
        path: '/metas-e-indicadores/editar/:id',
        name: 'variable-pay.update',
        component: () => import('../views/variable_pay/variable-pay-update.vue')
    }, {
        path: '/metas-e-indicadores/:id',
        name: 'variable-pay-informations',
        component: () => import('../views/variable_pay/variable-pay-informations.vue')
    },
    {
        path: '/metas-e-indicadores/:id/colaboradores',
        name: 'variable-pay-collaborators',
        component: () => import('../views/variable_pay/variable-pay-collaborators.vue')
    },
    {
        path: '/metas-e-indicadores/:id/historico-configuracao',
        name: 'variable-pay-histories',
        component: () => import('../views/variable_pay/variable-pay-histories.vue')
    },
    {
        path: '/metas-e-indicadores/:id/colaboradores/:collaborator_id/vizualizar',
        name: 'variable-pay-collaborator.view',
        component: () => import('../views/variable_pay/variable-pay-collaborators-view.vue')
    }
];

const router = new createRouter({
    // mode: 'history',
    history: createWebHistory(),
    linkExactActiveClass: 'active',
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { left: 0, top: 0 };
        }
    }
});

router.beforeEach(async (to, from, next) => {
    //Pesquisa segmentada
    if (to?.name && to.name.includes('external_segmented_survey')) {
        if (to?.meta?.layout) store.commit('setLayout', to?.meta?.layout);
        else store.commit('setLayout', 'segmented-survey');
        await handleMiddleware(to, from, next);
    } else {
        //Deepes
        await store.dispatch('user/loadUserData');

        if (!store.state.user.user?.permissions?.includes('role:collaborator') && to.meta.layout === 'portal') {
            window.location.href = '/login';
        }
        if (store.state.user.user?.permissions?.includes('role:collaborator') && to.meta.layout === undefined) {
            window.location.href = '/login';
        }

        if (to.meta && to.meta.layout && to.meta.layout === 'auth') {
            store.commit('setLayout', 'auth');

        } else if (to.meta && to.meta.layout && to.meta.layout === 'portal') {
            if (!store.getters['user/isAuth']) {
                window.location.href = '/login';
            }

            store.commit('setLayout', 'portal');
        } else {
            if (!store.getters['user/isAuth']) {
                window.location.href = '/login';
            } else {
                if (store.state.user.user.permissions.includes('role:collaborator')) {
                    window.location.href = '/portal';
                }
            }

            store.commit('setLayout', 'app');
        }

        if (store.getters['user/isAuth']) {
            const formAccess = { url_path: to.fullPath };

            let column_log = 'user_id';
            if (store.state.user.user.permissions.includes('role:collaborator')) {
                column_log = 'collaborator_id';
            }

            formAccess[column_log] = store.state.user.user.id;
            store.dispatch('user/accessLog', formAccess);
        }

        next(true);
    }
});

export default router;
